import { fileSchema, locationSchema } from "@/types/schema";
import * as z from "zod";

export const addPostSchema = z.object({
  postId: z.number().optional(),
  prompt: z.string().nullish(),
  description: z.string().min(1, "Required"),
  location: locationSchema.optional(),
  files: fileSchema.array().nullish(),
  externalLinks: z.string().nullish(),
  title: z.string().optional(),
});

export type AddPostSchemaModel = z.infer<typeof addPostSchema>;

export const editProfileSchema = z.object({
  profileImageUrl: z.string().nullish(),
  firstName: z.string().min(1, "Required"),
  lastName: z.string().min(1, "Required"),
  email: z.string().min(1, "Required"),
  mobile: z.string().nullish(),
  locationDetail: z.string().optional(),
  distanceRadius: z.number().optional(),
  location: locationSchema.optional(),
  profileImage: fileSchema.nullish(),
});

export type EditProfileSchemaModel = z.infer<typeof editProfileSchema>;

export const addEventSchema = z.object({
  postId: z.number().optional(),
  eventId: z.coerce.number().optional(),
  title: z.string().nullish(),
  description: z.string().min(1, "Required"),
  location: locationSchema.optional(),
  files: fileSchema.array().nullish(),
  externalLinks: z.string().nullish(),
  eventTypeId: z.coerce.number().optional(),
  eventType: z.string().nullish(),
  startDate: z.coerce.date().optional(),
  startTime: z.coerce.date().optional(),
  endDate: z.coerce.date().optional(),
  endTime: z.coerce.date().optional(),
  timezoneId: z.coerce.number().optional(),
  isRecurringEvent: z.boolean().optional(),
});

export type AddEventSchemaModel = z.infer<typeof addEventSchema>;
